export module CloudStudio.Utils.WebServices {

    export class ServiceException
    {
        ClassName: string;      // Do not rename field name. This gets serialized!
        FaultCode: string;      // Do not rename field name. This gets serialized!
        FaultData: string;      // Do not rename field name. This gets serialized!
        Message: string;        // Do not rename field name. This gets serialized!
        StatusCode: number;
        StatusText: String;
    }

    export class WebServiceProxy 
    {
        private _url: string;

         // Constructor
        constructor(url: string)
        {
            this._url = url;
        }

        private MakeException(http: XMLHttpRequest): ServiceException
        {
            var result = new ServiceException();
            if (http.status == 0) {
                result.ClassName  = "NetworkError";
                result.Message    = "The request could not be sent";
            } else {
                result.ClassName  = "ServerError";
                result.Message    = http.responseText;
            }
            result.FaultCode  = "";
            result.FaultData  = "";
            result.StatusCode = http.status;
            result.StatusText = http.statusText;
            return result;
        }

        protected SendRequest(method: string, data: Object, successProc: (content: Object) => void, errorProc: (exception: ServiceException) => void)
        {
            var http = new XMLHttpRequest();
            var thisObject = this;
            http.onreadystatechange = function()
                {
                    var state = http.readyState;
                    if (state == 4) {
                        if (http.status == 200) {
                            successProc(JSON.parse(http.responseText));
                        } else if (http.status == 500) {
                            try
                            {
                                var obj = JSON.parse(http.responseText);
                                if (obj.Exception == null) 
                                {
                                    errorProc(thisObject.MakeException(http));
                                }
                                else 
                                {
                                    var ex = obj.Exception as ServiceException;
                                    ex.StatusCode = http.status;
                                    ex.StatusText = http.statusText;
                                    errorProc(ex);
                                }
                            }
                            catch (e)
                            {
                                errorProc(thisObject.MakeException(http));
                            }
                        } else {
                            errorProc(thisObject.MakeException(http));
                        }
                    }
                };
            http.open('POST', this._url + '/'+ method, true);
//			http.withCredentials = true;
            http.setRequestHeader('Content-Type', 'application/json; charset="utf-8"');
            http.send(JSON.stringify(data));
        }

   }

}